import { render } from "./HolidayList.vue?vue&type=template&id=7877cc88"
import script from "./HolidayList.vue?vue&type=script&lang=js"
export * from "./HolidayList.vue?vue&type=script&lang=js"

import "./HolidayList.vue?vue&type=style&index=0&id=7877cc88&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__